/**
 * @summary     app.startup.js
 * @description App JS Startup Controller
 * @version     1.0
 	> 1.0 Initial version
		- 02/10/2019
 * @author      Silas Garrison
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
 	- The first visit check should be handled a little differently than just relying on localStorage
*/

app.addFeature("startup", function () {
	"use strict";

	var self = this;

	/*
		Name: boot
		Use: PRIVATE.boot()
		Args: none
		Description: Boots up the app
	*/
	function boot() {
		app.ajax.request({
			url: "/",
			contentType: "application/json",
			responseType: "json",
			success: (res) => {
				if (res.responseJson && !res.responseJson.error) {
					app.config.settings = res.responseJson.data;
				} else {
					app.config.settings = {};
				}
			},
			error: () => {
				app.config.settings = {};
			},
			args: {
				data: {},
				token: app.dataStore.get("session.token"),
				task: "getAppConfigs",
			},
		});
	}

	/*
		NOTE:
			Initialize the whole app and sub components
	*/
	app.onInit(boot);
	app.init();

	return self;
});
